import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export interface Crumb {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  /**
   * Visual tone. Use "dark" when the crumbs sit on a dark/navy background
   * (e.g. inside a gradient hero) for readable contrast.
   */
  tone?: "light" | "dark";
}

export const Breadcrumbs = ({ items, tone = "light" }: BreadcrumbsProps) => {
  const isDark = tone === "dark";
  const baseColor = isDark ? "text-white/70" : "text-muted-foreground";
  const linkHover = isDark ? "hover:text-gold" : "hover:text-gold";
  const currentColor = isDark ? "text-white font-semibold" : "text-navy font-semibold";

  return (
    <nav aria-label="Breadcrumb" className={`text-sm mb-6 ${baseColor}`}>
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${c.name}-${i}`} className="flex items-center gap-1">
              {c.href && !last ? (
                <Link to={c.href} className={`transition-colors ${linkHover}`}>
                  {c.name}
                </Link>
              ) : (
                <span className={last ? currentColor : ""}>{c.name}</span>
              )}
              {!last && <ChevronRight className="w-3.5 h-3.5 opacity-60" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
